import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  modalOpen: false,
  file: null,
  conf: null,
  searchQuery: null
};

export const fileViewerSlice = createSlice({
  name: 'fileViewer',
  initialState,
  reducers: {
    updateModalOpen: (state, action) => {
      state.modalOpen = action.payload;
    },
    updateFile: (state, action) => {
      state.file = action.payload ? { ...action.payload } : null;
    },
    updateConf: (state, action) => {
      state.conf = action.payload ? { ...action.payload } : null;
    },
    updateSearchQuery: (state, action) => {
      state.searchQuery = action.payload ?? null;
    }
  }
});

// Action creators are generated for each case reducer function
export const { updateModalOpen, updateFile, updateConf, updateSearchQuery } =
  fileViewerSlice.actions;

export default fileViewerSlice.reducer;
